import { Registry } from '@react-registry'

export const H4Deserializer = () => {
  return {
    type: 'h4'
  }
}

Registry.register(H4Deserializer, { id: 'H4', registry: 'v2.deserializer' })
